import { FormattedMessage, useIntl } from "react-intl";
import { useQueryClient } from "@tanstack/react-query";
import { DeleteActionButton, ActionButton } from "../ActionBar";
import {
  formatDate,
  formatDateTime,
  isSomething,
  isEmpty,
  exportDataStatusIconClassName,
} from "../../utils";

import { dataExportShape } from "../../shapes/dataExportShape";
import DataExportStatus from "../../constants/DataExportStatus";
import { withSession, trackingShape, withTracking } from "../../context";
import { useApi } from "../../hooks";

type Props = {
  session?: {
    token?: string;
  };
  dataExport?: dataExportShape;
  token?: string;
  tracking: trackingShape;
};

export function DataExportItem({ session, dataExport, tracking }: Props) {
  const api = useApi();
  const intl = useIntl();
  const queryClient = useQueryClient();
  const { mutate: handleDeleteDataExport } = api.delete.useMutation(
    `/users/current/data_exports/${
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      dataExport.id
    }`,
    {
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: ["/users/current/data_exports"],
        }),
    },
  );

  const handleDownload = () => {
    tracking.trackEvent("DataExportItem-clicked");
    window.open(
      `${
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        dataExport.downloadHref
      }?access_token=${
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        session.token
      }`,
      "_self",
    );
  };

  const finishedAt = dataExport?.finishedAt
    ? formatDateTime(dataExport.finishedAt, intl)
    : "-";
  const availableUntil = dataExport?.availableUntil
    ? formatDate(dataExport.availableUntil, intl)
    : "-";
  const { serial_number: assetSerialNumber, id: assetId } =
    (dataExport as $TSFixMe)?.asset ?? {};
  const { tag: instrumentationTag, id: tagId } =
    (dataExport as $TSFixMe)?.instrumentation ?? {};
  const { name: nodeName, id: nodeId } = (dataExport as $TSFixMe)?.node ?? {};
  const { name: batchName, id: batchId } =
    (dataExport as $TSFixMe)?.batch ?? {};
  const {
    number: orderNumber,
    customer_purchase_order_number: customerPurchaseOrderNumber,
    id: orderId,
  } = (dataExport as $TSFixMe)?.purchaseOrder ?? {};
  const name =
    dataExport && dataExport.type === "complete"
      ? "-"
      : assetSerialNumber ||
        instrumentationTag ||
        nodeName ||
        batchName ||
        (customerPurchaseOrderNumber ?? orderNumber);
  const id = assetId || tagId || nodeId || batchId || orderId;
  const linkMap = new Map();
  linkMap.set("instrumentation_values", "/app/value/instrumentations/");
  linkMap.set("batch_values", "/app/value/batches/");
  linkMap.set("node_documents_recursive", "/app/library/nodes/");
  linkMap.set("asset_documents", "/app/library/assets/");
  linkMap.set("purchase_order_documents", "/app/library/orders/");
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const baseLink = linkMap.get(dataExport.type);

  return (
    <tr>
      <td>
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        <div className={exportDataStatusIconClassName(dataExport.status)} />
      </td>
      <td>
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        <FormattedMessage id={`data_export.type.${dataExport.type}`} />
      </td>
      <td className="hidden-xs">
        {baseLink ? <a href={`${baseLink}${id}`}>{name}</a> : name}
      </td>
      <td className="hidden-xs">
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {formatDateTime(dataExport.createdAt, intl)}
      </td>
      <td className="hidden-xs">{finishedAt}</td>
      <td>{availableUntil}</td>
      <td className="right">
        <ActionButton
          id="download-export-file-button"
          icon="icon-eh-save"
          label="Download"
          defaultLabel={intl.formatMessage({ id: "button.download" })}
          onClick={handleDownload}
          disabled={
            !isSomething(dataExport) ||
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            dataExport.status !== DataExportStatus.DONE ||
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            isEmpty(dataExport.downloadHref)
          }
        />
        <DeleteActionButton
          id="delete-export-file-button"
          modalTitle={intl.formatMessage({ id: "export_delete.modal_title" })}
          modalMessage={intl.formatMessage({
            id: "export_delete.modal_message",
          })}
          disabled={
            isSomething(dataExport) &&
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            dataExport.status === DataExportStatus.IN_PROGRESS
          }
          onConfirm={() => handleDeleteDataExport()}
        />
      </td>
    </tr>
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type '({ session, dataExport, tracking... Remove this comment to see the full error message
export default withTracking(withSession(DataExportItem));
